import { FormGroup } from '@angular/forms';

import { forkJoin, Subscription } from "rxjs";
import { BOPerson } from "../models/BOPerson.model";
import { BOItem } from "../models/BOItem.model";
import { BOPayType } from "../models/BOPayType.model";
import { BOInvoiceType } from "../models/BOInvoiceType.model";
import { BOSubServiceType } from "../models/BOSubServiceType.model";
import { formatDate } from '@angular/common';
import { BOToothStateType } from '../models/odo/BOToothStateType.model';
import { BOToothStateCategory } from '../models/BOToothStateCategory.model';


export class Utilities {
  busy: Subscription;
 // profesionals: BOPerson[];
  static servicesTypeList: BOItem[];
  static servicesGroupList: BOItem[];
  static profesionals: BOPerson[];
  static payTypeList: BOPayType[];



  constructor(){ }


//id:number

  static getNameWithNumberFromList<T extends { id: number; name: string }>(
    id: number,
    myList: T[]
  ): string
  {
    const item = myList.find((element) => element.id == id);
    return item ? `${item.name}` : "Not Found";
  }


  static getProfesionalName(idProfessional:number, profesionals:BOPerson[]):string
  {
    let name:string="";

    profesionals.forEach(p=>{
      if(p.id==idProfessional)
      {
        if(typeof p.secondName ==="string") p.secondName.trim();
        if(p.secondName ==null || p.secondName==undefined) p.secondName="";

        if(p.secondName.length>0) name=p.firstName +' '+p.secondName +' ';
        else name=p.firstName +' '+ p.firtsSurName +' ';

        if(typeof p.secondSurName ==="string") p.secondSurName .trim();
        if(p.secondSurName ==null || p.secondSurName==undefined) p.secondSurName="";

        if(p.secondSurName.length>0) name=name+p.secondSurName;


      }
    });
    return name;
  }


static getNameFromPerson(p: BOPerson): string {
  if (!p) return "";

  const parts: string[] = [];

  // Nombres
  if (p.firstName?.trim()) parts.push(p.firstName.trim());
  if (p.secondName?.trim()) parts.push(p.secondName.trim());

  // Apellidos – ¡CORREGIDO EL TYPO EN LA CLASE!
  if (p.firtsSurName?.trim()) parts.push(p.firtsSurName.trim());  // ← debe existir en la clase
  if (p.secondSurName?.trim()) parts.push(p.secondSurName.trim());

  return parts.join(" ");
}


  static getNameFromPersonByData( firstName:string, secondName:string,firstSurName:string, secondSurName:string ):string
  {
    let name:string="";

        firstName=firstName.trim();
        secondName= secondName.trim();
        firstSurName=firstSurName.trim();
        secondSurName=secondSurName.trim();

        if( secondName ==null ||  secondName==undefined || secondName=="")  secondName="";

        if( secondName.length>0) name= firstName +' '+ secondName;
        else name= firstName +' '+  firstSurName;

        if( secondSurName ==null ||  secondSurName==undefined || secondSurName=="")
        {
            //secondSurName="";
            name=name + ' ' + firstSurName;
        }

       // if( secondSurName.length>0) name=name + ' ' + secondSurName;
        if( secondSurName.length>0) name=name + ' ' + firstSurName +' '+secondSurName;


    return name;
  }

  static getNameFromPersonArrayById(idPerson:number, data:BOPerson[]):string
  {
    let name:string="";

    data.forEach(p=>{
      if(p.id==idPerson)
      {
        if(typeof p.secondName ==="string") p.secondName .trim();
        if(p.secondName ==null || p.secondName==undefined) p.secondName="";

        if(p.secondName.length>0) name=p.firstName +' '+p.secondName +' ';
        else name=p.firstName +' '+ p.firtsSurName +' ';

        if(typeof p.secondSurName ==="string") p.secondSurName .trim();
        if(p.secondSurName ==null || p.secondSurName==undefined) p.secondSurName="";

        if(p.secondSurName.length>0) name=name+p.secondSurName;


      }
    });
    return name;
  }

  static getPayTypeName(idPayType: number, payTypeList: BOPayType[]):string
  {
    let name:string="";

    payTypeList.forEach(p=>{
      if(p.id==idPayType)
      {
        name=p.name;
      }
    });
    return name;

  }

  static getInvoiceTypeName(idInvoiceType: number, invoiceTypeList: BOInvoiceType[])
  {
    let name:string="";

    invoiceTypeList.forEach(p=>{
      if(p.id==idInvoiceType)
      {
        name=p.name;
      }
    });
    return name;

  }

  static getSubServiceTypeName(idSubServiceType: number, subServiceTypeList: BOItem[])
  {
    let name:string="";

    subServiceTypeList.forEach(sb=>{
      if(sb.id==idSubServiceType)
      {
        name=sb.name;
      }
    });
    return name;

  }

  static getServiceTypeName(idServiceType: number, serviceTypeList: BOItem[])
  {
    let name:string="";

    serviceTypeList.forEach(g=>{
      if(g.id==idServiceType)
      {
        name=g.name;
      }
    });
    return name;

  }

  static getIdTypeName(idType: number, idTypeList: BOItem[])
  {
    let code:string="";

    idTypeList.forEach(g=>{
      if(g.id==idType)
      {
        code=g.code;
      }
    });
    return code;
  }

  static getGroupTypeName(idGroupType: number, groupTypeList: BOItem[])
  {
    let name:string="";

    groupTypeList.forEach(g=>{
      if(g.id==idGroupType)
      {
        name=g.name;
      }
    });
    return name;

  }

  static getGroupsByAreaId(idArea: number, groupTypeList: BOItem[]):BOItem[]
  {
    let serviceGroupsListShortTemp: BOItem[] = [];

    groupTypeList.forEach(g=>{
      if(g.areaId==idArea)
      {
        serviceGroupsListShortTemp.push(g);

      }
    });
    return serviceGroupsListShortTemp;
  }

  static getGenderIdentityName(genderIdentityId: number, genderIdentityList: BOItem[])
  {
    let name:string="";

    genderIdentityList.forEach(g=>{
      if(g.id==genderIdentityId)
      {
        name=g.name;
      }
    });
    return name;

  }

  static getTriageName(triageId: number, triageList: BOItem[])
  {
    let name:string="";

    triageList.forEach(sb=>{
      if(sb.id==triageId)
      {
        name=sb.name;
      }
    });
    return name;

  }


  static getProfessionalssByAreaId(idPro: number, professionalList: BOPerson[]):BOPerson[]
  {
    let professionalListShortTemp: BOPerson[]= [];

    professionalList.forEach(p=>{
      if(p.area==idPro)
      {
        professionalListShortTemp.push(p);

      }
    });

      const pReverse: BOPerson[]=[...professionalListShortTemp].reverse();

    //return  professionalListShortTemp;
        return  pReverse;

  }

  static getServicesByGroupId(idGroup: string, servicesTypeList: BOItem[]):BOItem[]
  {
    let servicesListShortTemp: BOItem[] = [];

    servicesTypeList.forEach(s=>{
      if(s.serviceGroup==idGroup)
      {
        servicesListShortTemp.push(s);

      }
    });
    return servicesListShortTemp;
  }
  static getStateName(stateId: number, stateList: BOToothStateType[])
  {
    let name:string="";

    stateList.forEach(g=>{
      if(g.id==stateId)
      {
        name=g.name;
      }
    });
    return name;

  }


  static convertDateToString(date:Date):string{

    const dateTemp=date;
    const dateTempReal=new Date(dateTemp);
    const day=dateTempReal.getDate();
    const month=dateTempReal.getMonth() +1;
    const year= dateTempReal.getFullYear();
    const resultDate=day +'/'+month+ '/'+ year;

    return resultDate;
   }

   static convertDateToStringFromDate(date: Date): string
   {

      if (!(date instanceof Date) || isNaN(date.getTime())) {
        return '';
      }

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
}
static convertDateStringToString(dateString: string): string {

  if (!dateString) {
    return '';
  }

  const [datePart] = dateString.split('T');
  const [year, month, day] = datePart.split('-');

  return `${day}/${month}/${year}`;
}
static convertDateStringToDDMMYYYY(dateString: string): string {

  if (!dateString) {
    return '';
  }

  const [datePart] = dateString.split('T');
  const [year, month, day] = datePart.split('-');

  return `${day}/${month}/${year}`;
}

/**
 * Convierte una cadena con formato "dd/MM/yyyy, HH:mm:ss" en un objeto Date
 * @param fechaStr Ejemplo: "26/11/2025, 09:30:43"
 * @returns Date válido o null si el formato es incorrecto
 */
static parseFechaHora(fechaStr: string): Date | null {
  // Validación básica de formato con expresión regular
  const regex = /^(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})$/;
  const match = fechaStr.match(regex);

  if (!match) {
    console.warn(`Formato de fecha inválido: "${fechaStr}". Se esperaba: dd/MM/yyyy, HH:mm:ss`);
    return null;
  }

  const [, diaStr, mesStr, añoStr, horasStr, minutosStr, segundosStr] = match;

  const dia = parseInt(diaStr, 10);
  const mes = parseInt(mesStr, 10);
  const año = parseInt(añoStr, 10);
  const horas = parseInt(horasStr, 10);
  const minutos = parseInt(minutosStr, 10);
  const segundos = parseInt(segundosStr, 10);

  // Validación adicional de rangos
  if (
    mes < 1 || mes > 12 ||
    dia < 1 || dia > 31 ||
    horas > 23 || minutos > 59 || segundos > 59
  ) {
    console.warn(`Valores fuera de rango en la fecha: "${fechaStr}"`);
    return null;
  }

  // Crear el Date (mes en JS es 0-based → restamos 1)
  const fecha = new Date(año, mes - 1, dia, horas, minutos, segundos);

  // Verificar que la fecha sea válida (evita cosas como 31/04/2025)
  if (
    fecha.getFullYear() !== año ||
    fecha.getMonth() !== mes - 1 ||
    fecha.getDate() !== dia ||
    fecha.getHours() !== horas ||
    fecha.getMinutes() !== minutos ||
    fecha.getSeconds() !== segundos
  ) {
    console.warn(`Fecha inválida (día/mes incoherente): "${fechaStr}"`);
    return null;
  }

  return fecha;
}

static displayDateWithFormat(date: Date | null): string {
    if (!date) return '';
    return formatDate(date, 'dd/MM/yyyy', 'es-ES');
  }




   static convertStringToInt(target:string):number{

    const intTemp=parseInt(target);

    return intTemp;
   }

   static getServicesxGroupId(idGroup: string, serviceList: BOItem[]):BOItem[]
   {
     let svcList: BOItem[]=[];

     serviceList.forEach(s=>{
       if(s.serviceGroup==idGroup)
       {
         svcList.push(s);
       }
     });
     return svcList ;
   }

   static getSubServicesxServiceId(idService: number, subServiceTypeList: BOSubServiceType[]):BOSubServiceType[]
   {

     let svcList: BOSubServiceType[]=[];

     subServiceTypeList.forEach(sb=>{
       if(sb.serviceTypeId==idService)
       {
         svcList.push(sb);
       }
     });
     return svcList ;
   }

  static getMonthFromDate(month:string):number{
    switch(month)
    {

      case 'Jan':{
        return 1;
      }
      case 'Feb':{
        return 2;
      }
      case 'Mar':{
        return 2;
      }
      case 'Apr':{
        return 3;
      }
      case 'May':{
        return 4;
      }
      case 'Jun':{
        return 5;
      }
      case 'Jul':{
        return 6;
      }
      case 'Aug':{
        return 7;
      }
      case 'Sep':{
        return 8;
      }
      case 'Oct':{
        return 9;
      }
      case 'Nov':{
        return 10;
      }
      case 'Dec':{
        return 11;
      }
    }

  } //End getMonthFromDate


static convertDateToSqlFormat(dateString: string): string {
  // Crear objeto Date desde el string
  const date = new Date(dateString);

  // Verificar si la fecha es válida
  if (isNaN(date.getTime())) {
    throw new Error('Formato de fecha inválido');
  }

  // Obtener componentes de la fecha
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Formatear para SQL Server: YYYY-MM-DD HH:mm:ss.0000000
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.0000000`;
}



static calculateAge(birthDate: Date | string): number {
  // Convertir a Date si es string
  const birth = new Date(birthDate);
  const today = new Date();

  // Validar que la fecha sea válida
  if (isNaN(birth.getTime())) {
    throw new Error('Fecha de nacimiento inválida');
  }

  // Validar que la fecha no sea futura
  if (birth > today) {
    throw new Error('La fecha de nacimiento no puede ser futura');
  }

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  // Ajustar edad si aún no ha cumplido años este año
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

static getMonthsIfUnderOneYear(birthDate: Date | string | null | undefined): number | null {
  if (!birthDate) return null;

  const birth = new Date(birthDate);
  const today = new Date();

  // Validaciones
  if (isNaN(birth.getTime())) {
    throw new Error('Fecha de nacimiento inválida');
  }
  if (birth > today) {
    throw new Error('La fecha de nacimiento no puede ser futura');
  }

  const years = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();
  const days = today.getDate() - birth.getDate();

  // Ajuste por día del mes
  if (days < 0) {
    months--;
  }

  // Ajuste si cruza el año
  if (months < 0) {
    months += 12;
  }

  const totalMonths = years * 12 + months;

  // Solo devolvemos meses si es menor a 12 meses completos
  return totalMonths < 12 ? totalMonths : null;
}

static getBabyAgeAsString(birthDate: Date | string | null | undefined): string | null {
  if (!birthDate) return null;

  const birth = new Date(birthDate);
  const today = new Date();

  // Validaciones
  if (isNaN(birth.getTime())) {
    console.warn('Fecha de nacimiento inválida:', birthDate);
    return null;
  }
  if (birth > today) {
    console.warn('Fecha de nacimiento futura:', birthDate);
    return null;
  }

  // Calcular diferencia en milisegundos
  const diffMs = today.getTime() - birth.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)); // días completos

  // Si tiene menos de 30 días → devolver en días
  if (diffDays < 30) {
    return `${diffDays} día${diffDays !== 1 ? 's' : ''}`;
  }

  // Calcular meses completos
  let years = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();
  const days = today.getDate() - birth.getDate();

  if (days < 0) {
    months--;
  }
  if (months < 0) {
    years--;
    months += 12;
  }

  const totalMonths = years * 12 + months;

  // Si tiene 12 meses o más → no mostrar edad de bebé
  if (totalMonths >= 12) {
    return null;
  }

  // Entre 1 y 11 meses → devolver en meses
  return `${totalMonths} mes${totalMonths !== 1 ? 'es' : ''}`;
}


static converToFloat(data: string): number | null {
  // Expresión regular para validar un número entero o decimal (opcional).
  // ^-?      -> Permite un signo negativo opcional al inicio.
  // \d+      -> Requiere uno o más dígitos.
  // (\.\d+)? -> Permite un grupo opcional de punto decimal seguido de dígitos.
  // $        -> Asegura que no haya nada después del número.
  const numberRegex = /^-?\d+(\.\d+)?$/;

  if (!numberRegex.test(data)) {
    console.error(`Formato de inválido: "${data}". El string debe ser un número puro.`);
    return null;
  }

  // Si la validación estricta pasa, la conversión es segura.
  const numericValue = parseFloat(data);
  return Math.trunc(numericValue);
}

static convertStringToDate(dateStr: string | null | undefined): Date | null {
  if (!dateStr || dateStr.trim() === '') {
    return null;
  }

  // Si ya es un formato ISO válido (con o sin T), new Date() lo entiende perfectamente
  const date = new Date(dateStr);

  // Validamos que sea una fecha válida (evita cosas como "Invalid Date")
  return isNaN(date.getTime()) ? null : date;
}

  static getRelativeTypeName(relativeCode: string, relativeTypeList: BOItem[]):string
  {
    let name:string="";

    relativeTypeList.forEach(item=>{
      if(item.code==relativeCode)
      {
        name=item.name;
      }
    });
    return name;

  }

  static getAllergyTypeName(allergyCode: string, medicAllergyTypeList: BOItem[]):string
  {
    let name:string="";

    medicAllergyTypeList.forEach(item=>{
      if(item.code==allergyCode)
      {
        name=item.name;
      }
    });
    return name;

  }

  static getNameByIdFromBOItem(itemId: number, itemList: BOItem[]):string
  {
    let name:string="";

    itemList.forEach(item=>{
      if(item.id==itemId)
      {
        name=item.name;
      }
    });
    return name;

  }

  static ConvertNumberToString(value: number): string
  {
    if (value >= 1 && value <= 9) {
      return '0' + value;
    }
    return String(value);
  }

  static generarateGUI(): string
  {
  return `tmp_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
  }


  static getToothStatesTypeaByCategory(item: BOToothStateCategory , groupTypeList: BOToothStateType[]):BOToothStateType[]
  {
    let toothStateTypeListShortTemp: BOToothStateType[] = [];

    groupTypeList.forEach(g=>{
      if(g.toothStateCategoryId==item.id)
      {
        toothStateTypeListShortTemp.push(g);

      }
    });
    return toothStateTypeListShortTemp;
  }



}
